import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import Select from 'components/Form/Select';
import TextField from 'components/Form/TextField';
import Button from 'components/Button';
import GatedSubscribeForm from 'components/Tools/GatedSubscribeForm';
import FlowRateResult from '../Result';
import { FormulaFlowRate } from '../styles';
import { FormContainer } from '../../styles';
import {
  MeasureUnitsDiameter,
  MeasureUnitsVolume,
  VelocityUnits,
  TimeUnits,
} from '../utils/content';

const FlowRateForm = ({ gatedForm, ...props }) => {
  const [isUpdate, setUpdate] = useState(false);

  const [values, setValues] = useState({
    diameter: '',
    diameterMeas: 1,
    velocity: '',
    velocityMeas: 1,
    volume: '',
    volumeMeas: 0.001044,
    time: '',
    timeMeas: 1,
  });

  const [formValid, setFormValid] = useState({
    diameter: 0,
    diameterMeas: 0,
    velocity: 0,
    velocityMeas: 0,
    volume: 0,
    volumeMeas: 0,
    time: 0,
    timeMeas: 0,
  });

  const [gateFormCookieIncrease, setGateFormCookieIncrease] = useState({
    tab1: 0,
    tab2: 0,
  });
  const [isRecalc, setRecalc] = useState({
    tab1: false,
    tab2: false,
  });
  const [doCalc, setDoCalc] = useState({
    tab1: false,
    tab2: false,
  });

  const [tabKey, setTabKey] = useState('1');

  const checkFieldValidate = (id, value) => {
    const fieldValidation = formValid;

    if (id === 'diameter' || id === 'velocity' || id === 'volume' || id === 'time') {
      fieldValidation[id] =
        value !== '' && value.match(/^[0-9]+$/) && parseFloat(value) > 0 ? 1 : -1;
    } else {
      fieldValidation[id] = value !== '' ? 1 : -1;
    }
    setFormValid(fieldValidation);
    setUpdate(!isUpdate);
    return fieldValidation[id];
  };

  const checkValidate = () => {
    const fields =
      tabKey === '1'
        ? ['diameter', 'diameterMeas', 'velocity', 'velocityMeas']
        : ['volume', 'volumeMeas', 'time', 'timeMeas'];
    const valid = fields.filter(element => checkFieldValidate(element, values[element]) == 1)
      .length;
    return valid === fields.length;
  };

  const onHandleChange = e => {
    const { name, value } = e.target;
    setValues(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onHandleChangeSelect = (id, newValue) => {
    const tmpValues = { ...values };
    tmpValues[id] = newValue;
    setValues(tmpValues);

    checkFieldValidate(id, newValue);
  };

  const handleCalcButton = () => {
    if (
      !checkValidate() ||
      (tabKey === '1' && !isRecalc.tab1) ||
      (tabKey === '2' && !isRecalc.tab2)
    ) {
      return;
    }

    if (tabKey === '1') {
      setDoCalc({ ...doCalc, tab1: !doCalc.tab1 });
      setRecalc({ ...isRecalc, tab1: false });
      setGateFormCookieIncrease({
        ...gateFormCookieIncrease,
        tab1: gateFormCookieIncrease.tab1 + 1,
      });
    } else {
      setDoCalc({ ...doCalc, tab2: !doCalc.tab2 });
      setRecalc({ ...isRecalc, tab2: false });
      setGateFormCookieIncrease({
        ...gateFormCookieIncrease,
        tab2: gateFormCookieIncrease.tab2 + 1,
      });
    }
  };

  useEffect(() => {
    setRecalc({ ...isRecalc, tab1: true });
  }, [values['diameter'], values['diameterMeas'], values['velocity'], values['velocityMeas']]);

  useEffect(() => {
    setRecalc({ ...isRecalc, tab2: true });
  }, [values['volume'], values['volumeMeas'], values['time'], values['timeMeas']]);

  return (
    <FormContainer {...props}>
      <div className="section-tool-page-form--wrapper">
        <div className="section-tool-page-form--container">
          <FormulaFlowRate>
            <Tabs
              type="card"
              onChange={key => {
                setTabKey(key);
                setUpdate(!isUpdate);
              }}
            >
              <Tabs.TabPane tab="Diameter & Velocity" key="1">
                <div className="section-flowrate-form--form">
                  <div className="section-flowrate-form--left-side">
                    <GatedSubscribeForm
                      increaseCookie={gateFormCookieIncrease.tab1}
                      update={isUpdate}
                      gatedForm={gatedForm}
                    >
                      <div className="section-flowrate-form--left-row">
                        <div className="section-flowrate-form--row-title">
                          <h4>Diameter:</h4>
                        </div>
                        <div className="section-flowrate-form--row-content">
                          <TextField
                            id="diameter"
                            type="number"
                            className="section-flowrate-form--input value-diameter"
                            values={values}
                            formValid={formValid}
                            onChange={onHandleChange}
                            showOnlyFormError
                          />
                          <Select
                            id="diameterMeas"
                            className="section-flowrate-form--select"
                            formValid={formValid}
                            placeholder="Choose measure unit"
                            options={MeasureUnitsDiameter}
                            values={values}
                            handleChange={onHandleChangeSelect}
                            width={'100%'}
                          />
                        </div>
                      </div>

                      <div className="section-flowrate-form--left-row">
                        <div className="section-flowrate-form--row-title">
                          <h4>Velocity:</h4>
                        </div>
                        <div className="section-flowrate-form--row-content value-velocity">
                          <TextField
                            id="velocity"
                            type="number"
                            className="section-flowrate-form--input"
                            values={values}
                            formValid={formValid}
                            onChange={onHandleChange}
                            showOnlyFormError
                          />
                          <Select
                            id="velocityMeas"
                            className="section-flowrate-form--select"
                            formValid={formValid}
                            placeholder="Choose measure unit"
                            options={VelocityUnits}
                            values={values}
                            handleChange={onHandleChangeSelect}
                          />
                        </div>
                      </div>

                      <Button shadow={false} onClick={handleCalcButton} width={'100%'}>
                        Calculate
                      </Button>
                    </GatedSubscribeForm>
                    <p className="section-flowrate-form--label">
                      Learn how we calculated this result{' '}
                      <a href="#section-tool-page-content--container">below</a>.
                    </p>
                  </div>

                  <div className="section-flowrate-form--right-side">
                    <FlowRateResult type={1} values={values} doCalc={doCalc.tab1} />
                  </div>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Volume & Time" key="2">
                <div className="section-flowrate-form--form">
                  <div className="section-flowrate-form--left-side">
                    <GatedSubscribeForm
                      gatedForm={gatedForm}
                      increaseCookie={gateFormCookieIncrease.tab2}
                      update={isUpdate}
                    >
                      <div className="section-flowrate-form--left-row">
                        <div className="section-flowrate-form--row-title">
                          <h4>Volume:</h4>
                        </div>
                        <div className="section-flowrate-form--row-content">
                          <TextField
                            id="volume"
                            type="number"
                            className="section-flowrate-form--input"
                            values={values}
                            formValid={formValid}
                            onChange={onHandleChange}
                            showOnlyFormError
                          />
                          <Select
                            id="volumeMeas"
                            className="section-flowrate-form--select"
                            formValid={formValid}
                            placeholder="Choose measure unit"
                            options={MeasureUnitsVolume}
                            values={values}
                            handleChange={onHandleChangeSelect}
                            width={'100%'}
                          />
                        </div>
                      </div>

                      <div className="section-flowrate-form--left-row">
                        <div className="section-flowrate-form--row-title">
                          <h4>Time:</h4>
                        </div>
                        <div className="section-flowrate-form--row-content">
                          <TextField
                            id="time"
                            type="number"
                            className="section-flowrate-form--input"
                            values={values}
                            formValid={formValid}
                            onChange={onHandleChange}
                            showOnlyFormError
                          />
                          <Select
                            id="timeMeas"
                            className="section-flowrate-form--select"
                            formValid={formValid}
                            placeholder="Choose measure unit"
                            options={TimeUnits}
                            values={values}
                            handleChange={onHandleChangeSelect}
                          />
                        </div>
                      </div>

                      <Button shadow={false} onClick={handleCalcButton} width={'100%'}>
                        Calculate
                      </Button>
                    </GatedSubscribeForm>
                    <p className="section-flowrate-form--label">
                      Learn how we calculated this result{' '}
                      <a href="#section-tool-page-content--container">below</a>.
                    </p>
                  </div>
                  <div className="section-flowrate-form--right-side">
                    <FlowRateResult type={2} values={values} doCalc={doCalc.tab2} />
                  </div>
                </div>
              </Tabs.TabPane>
            </Tabs>
          </FormulaFlowRate>
        </div>
      </div>
    </FormContainer>
  );
};

export default FlowRateForm;
